import React from 'react'
import AdminLayout from '../../components/Admin/AdminLayout'
import Chat from '../Chat'
import Email from '../Email'
import Files from '../Files'
import Digest from '../Digest'

export function AdminEmailPage() {
  return (
    <AdminLayout flush bare>
      <Email embedded />
    </AdminLayout>
  )
}

export function AdminFilesPage() {
  return (
    <AdminLayout flush bare>
      <Files embedded />
    </AdminLayout>
  )
}

export function AdminDigestPage() {
  return (
    <AdminLayout flush bare>
      <div className="admin-tool-shell admin-tool-shell-full admin-digest-embedded">
        <Digest embedded />
      </div>
    </AdminLayout>
  )
}

export function AdminChatPage() {
  return (
    <AdminLayout flush bare>
      <div className="admin-tool-shell admin-tool-shell-full">
        <Chat embedded />
      </div>
    </AdminLayout>
  )
}
